// Third Party Imports
import React from 'react';

// Relative Imports
import activationProcess from '../../images/activation-process';
import {SVGIcon} from '@homeaway/react-svg';

const ActivationProcessDiagram = (props) => {
    const {translations} = props;
    return (<div className="resources-wrapper activation-illustration-content">
        <h3 className="activation-illustration-heading">
            {translations['ipmob.complete.activation_process.heading']}
        </h3>
        <div className="activation-illustration-holder">
            <div className="activation-illustration" ><SVGIcon markup={activationProcess}/></div>
            <div className="process-steps-holder">
                <div className="process-steps step1">
                    <p>{1}</p>
                    <p>{translations['ipmob.complete.activation_process.step1']}</p>
                </div>
                <div className="process-steps step2">
                    <p>{2}</p>
                    <p>{translations['ipmob.complete.activation_process.step2']}</p>
                </div>
                <div className="process-steps step3">
                    <p>{3}</p>
                    <p>{translations['ipmob.complete.activation_process.step3']}</p>
                </div>
                <div className="process-steps step4">
                    <p>{4}</p>
                    <p>{translations['ipmob.complete.activation_process.step4']}</p>
                </div>
                <div className="process-steps step5">
                    <p>{5}</p>
                    <p>{translations['ipmob.complete.activation_process.step5']}</p>
                </div>
            </div>
        </div>
    </div>);
};

export default ActivationProcessDiagram;